import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'
import { ChromePicker } from 'react-color'

class ColorPicker extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            showColorPicker: false,
            colour: props.colour,
        }
        this.colour = props.colour
    }

    changeColor = (colour) => {
        const { onChange } = this.props
        console.log(`changeColor ${JSON.stringify(colour)}`)
        const stateCopy = { ...this.state }
        stateCopy.colour = colour.hex
        if (onChange && typeof onChange === 'function') {
            onChange(colour)
        }
        this.colour = colour.hex
        // this.setState(stateCopy)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.updated !== this.props.updated) {
            const stateCopy = { ...this.state }
            stateCopy.colour = this.props.colour
            this.setState(stateCopy)
        }
    }

    toggleShow = () => {
        const stateCopy = { ...this.state }
        stateCopy.showColorPicker = !stateCopy.showColorPicker
        stateCopy.colour = this.colour
        this.setState(stateCopy)
    }

    render() {
        const { label } = this.props
        const mainCss = {
            display: 'inline-block',
            cursor: 'pointer',
            alignSelf: 'center',
        }
        const popover = {
            position: 'absolute',
            zIndex: '2',
            top: '45px',
            right: '10px',
        }
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }
        const fontColor = {
            width: '50px',
            height: '34px',
            borderRadius: '6px',
            background: this.state.colour,
            boxShadow: '3px 5px 8px hsla(0deg, 0%, 0%, 0.08)',
        }

        return (
            <div style={{ position: 'relative' }}>
                {this.state.showColorPicker &&
                    <div style={ popover }>
                        <div style={ cover } onClick={this.toggleShow}/>
                        <ChromePicker color={this.state.colour} onChange={this.changeColor} disableAlpha/>
                    </div>
                }
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: 10 }}>
                    <span style={{ alignSelf: 'center' }}>{label}</span>

                    <span style={mainCss} onClick={this.toggleShow}>
                        <div style={fontColor} />
                    </span>
                </div>
            </div>
        )
    }
}

export default ColorPicker
